import Api from "./api";

export default class ModelApi extends Api {
	updatePartial(url, data, onSuccess, onError) {
		this.Patch(url, data, onSuccess, onError);
	}

	update(url, data, onSuccess, onError) {
		this.Put(url, data, onSuccess, onError)
	}

	list(onSuccess, onError) {
		this.Get(this.baseUrl, onSuccess, onError);
	}

	retrieve(url, onSuccess, onError) {
		this.Get(url, onSuccess, onError);
	}

	delete(url, onSuccess, onError) {
		this.Delete(url, onSuccess, onError);
	}

	create(data, onSuccess, onError) {
		this.Post(this.baseUrl, data, onSuccess, onError);
	}
}
